module.exports = __webpack_public_path__ + "static/media/anonym1.d21ec384.svg";